import type { SegmentSchemaCatalog } from '@reach/shared-types/segment-schema-graph';
import { useMemo, type ReactNode } from 'react';
import type { SegmentFieldValueLoader } from '../SegmentFieldValues/types';
import { SegmentSchemaCatalogContext } from './segment-schema-catalog-context';

export interface SegmentSchemaCatalogProviderProps {
  schemaCatalog: SegmentSchemaCatalog | undefined;
  isLoading: boolean;
  isFetching: boolean;
  error: Error | null;
  retry: () => void;
  getFieldValues?: SegmentFieldValueLoader;
  children: ReactNode;
}

/** Supply one schema catalog to every condition component in a visual builder. */
export function SegmentSchemaCatalogProvider({
  schemaCatalog,
  isLoading,
  isFetching,
  error,
  retry,
  getFieldValues,
  children,
}: SegmentSchemaCatalogProviderProps) {
  const value = useMemo(() => {
    const schemasById = new Map(schemaCatalog?.schemas.map(schema => [schema.id, schema]));
    const getSchemaById = (schemaId: string) => schemasById.get(schemaId);
    return { schemaCatalog, isLoading, isFetching, error, retry, getSchemaById, getFieldValues };
  }, [schemaCatalog, isLoading, isFetching, error, retry, getFieldValues]);

  return (
    <SegmentSchemaCatalogContext.Provider value={value}>{children}</SegmentSchemaCatalogContext.Provider>
  );
}
